import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const Link = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { url , href , target , className , label ='' , download , children , labelAccessibility , ariaHasPopup , ariaIsExpanded , onClick , onKeyDown , onFocus , openInNewWindow , tabIndex , iconBefore , iconAfter , iconSize , isVisualOnly  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "url",
        "href",
        "target",
        "className",
        "label",
        "download",
        "children",
        "labelAccessibility",
        "ariaHasPopup",
        "ariaIsExpanded",
        "onClick",
        "onKeyDown",
        "onFocus",
        "openInNewWindow",
        "tabIndex",
        "iconBefore",
        "iconAfter",
        "iconSize",
        "isVisualOnly"
    ]);
    const isNewWindow = target === 'external' || target === '_blank' || openInNewWindow;
    const targetOpt = isNewWindow ? '_blank' : undefined;
    const rel = isNewWindow ? 'noreferrer noopener' : undefined;
    const hrefFallback = isVisualOnly ? '' : '#';
    const handleClick = (event)=>{
        if (isVisualOnly) {
            event === null || event === void 0 ? void 0 : event.preventDefault();
        }
        if (onClick) {
            onClick(event);
        }
    };
    const classes = classnames(className, {
        'link--with-icon': iconBefore || iconAfter
    }) || undefined;
    return(/* The linter throws an error that <a> does not support aria-haspopup.
       * However, the docs disagree and it has been shown to work in our testing with VoiceOver on Chrome
       * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-haspopup#associated_roles
       * */ // eslint-disable-next-line jsx-a11y/role-supports-aria-props
    /*#__PURE__*/ React.createElement("a", {
        ref: ref,
        className: classes,
        href: href || url || hrefFallback,
        target: targetOpt,
        rel: rel,
        "aria-label": labelAccessibility,
        download: download,
        "aria-haspopup": ariaHasPopup,
        "aria-expanded": ariaHasPopup ? ariaIsExpanded : undefined,
        onClick: handleClick,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        "data-t": rest['data-t'],
        tabIndex: tabIndex
    }, renderLinkIcon(iconBefore, iconSize), children ? children : label, renderLinkIcon(iconAfter, iconSize)));
});
Link.displayName = 'Link';
function renderLinkIcon(icon, iconSize) {
    return icon ? /*#__PURE__*/ React.createElement(Icon, {
        name: icon,
        width: iconSize === null || iconSize === void 0 ? void 0 : iconSize.width,
        height: iconSize === null || iconSize === void 0 ? void 0 : iconSize.height
    }) : null;
}

export { Link as default };
//# sourceMappingURL=Link.js.map
